import React, {useState, useCallback} from 'react'
import {sendCouponEmail} from '../../lib/emmiApi'
import {Navigate} from "react-router-dom"
import {LOG_EVENTS} from 'wipi-common/src/lib/logging/events'
import LOG from "wipi-common/src/lib/logging/logger";
import UnexpectedError from "../misc/UnexpectedError";
import PropTypes from "prop-types";
import {useI18nContext} from "../i18n/I18nContext";
import {getI18nTextWithContext} from "wipi-common/src/lib/i18n";

export default function SendCouponEmailButton({caseId, search}) {
    const [isEmailTriggered, setEmailTriggered] = useState(false)
    const [toMailConfirmed, setToMailConfirmed] = useState(false)
    const [isErrorSendingEmail, setErrorSendingEmail] = useState(false)
    const context = useI18nContext()
    const buttonDescription = getI18nTextWithContext(context, 'startBasic.sendCouponBtn')

    const sendEmail = useCallback(() => {
        setEmailTriggered(true)
        LOG.logInfo(LOG_EVENTS.BA_COUPON_EMAIL)
        sendCouponEmail(caseId)
            .then(() => setToMailConfirmed(true))
            .catch(() => {
                setEmailTriggered(false);
                setErrorSendingEmail(true);
            })
    }, [caseId])

    if (toMailConfirmed) {
        return <Navigate to={{pathname: "/basic/mail-confirmed", search}} />
    }
    if(isErrorSendingEmail) {
        return <UnexpectedError/>
    }
    return <button className="btn btn-secondary"
                   data-test-id="e32efe4d-1576"
                   onClick={sendEmail}
                   disabled={isEmailTriggered}
                   aria-label={buttonDescription}>
        {buttonDescription} &nbsp;
        <svg className="icon-arrow" aria-label="send coupon" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
             fill="none">
            <path id="arrow-right-icon" d="M0 9H12.17L6.58 14.59L8 16L16 8L8 0L6.59 1.41L12.17 7H0L0 9Z"/>
        </svg>
    </button>
}
SendCouponEmailButton.propTypes = {
    caseId: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired
}